import ImageService from 'src/modules/image/imageService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { i18n } from 'src/i18n';
import { navigateTo } from 'src/view/shared/routes/helpers';

const prefix = 'IMAGE_FORM';

const imageFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: imageFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await ImageService.find(id);
      }

      dispatch({
        type: imageFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: imageFormActions.INIT_ERROR,
      });

      navigateTo('/library/image');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: imageFormActions.CREATE_STARTED,
      });

      await ImageService.create(values);

      dispatch({
        type: imageFormActions.CREATE_SUCCESS,
      });

      Message.success(i18n('entities.image.create.success'));

      navigateTo('/library/image');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: imageFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: imageFormActions.UPDATE_STARTED,
      });

      await ImageService.update(id, values);

      dispatch({
        type: imageFormActions.UPDATE_SUCCESS,
      });

      Message.success(i18n('entities.image.update.success'));

      navigateTo('/library/image');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: imageFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default imageFormActions;
